{
  "defaultSite": "conference.historicalmaterialism.org",
  "sites": {

    "hm2025": {
      "conferenceYear": 2025,
      "conferenceMonth": 11,
      "title": "Historical Materialism Conference",
      "typesenseCollection": "panel_sessions_25",
      "publicdir": "hm2025",
      "elements": {
        "sidebar": true
      },
      "results" : {
        "showChair": true,
        "showBio": false,
        "showTeams": true,
        "showInPerson": false
      },
      "facets" : {
        "StreamName": "Stream",
        "BuildingFacet": true,
        "RoomFacet": false
      }
    },

    "conference.historicalmaterialism.org": {
      "conferenceYear": 2026,
      "conferenceMonth": 11,
      "title": "Historical Materialism 2026 Conference",
      "typesenseCollection": "hm2026",
      "publicdir": "hm2026",
      "elements": {
        "sidebar": true
      },
      "results" : {
        "showChair": true,
        "showBio": false,
        "showTeams": true,
        "showInPerson": false
      },
      "facets" : {
        "StreamName": "Stream",
        "BuildingFacet": false,
        "RoomFacet": true
      },
      "schedule": {
        "Thursday": {
          "Session 1": "10:00 - 11:45",
          "Session 2": "12:00 - 13:45",
          "Session 3": "14:30 - 16:15",
          "Session 4": "16:30 - 18:15",
          "Session 5": "19:00 - 21:00"
        },
        "Friday": {
          "Session 1": "09:30 - 11:15",
          "Session 2": "11:30 - 13:15",
          "Session 3": "14:15 - 16:00",
          "Session 4": "16:15 - 18:00",
          "Session 5": "18:30 - 20:00"
        },
        "Saturday": {
          "Session 1": "10:00 - 11:45",
          "Session 2": "12:00 - 13:45",
          "Session 3": "14:30 - 16:15",
          "Session 4": "16:30 - 18:15",
          "Session 5": "19:00 - 21:00"
        },
        "Sunday": {
          "Session 1": "10:30 - 12:15",
          "Session 2": "12:30 - 14:15",
          "Session 3": "14:45 - 16:30",
          "Session 5": "17:00 - 19:00"
        }
      }
    },

    "tapra": {
      "conferenceYear": 2026,
      "conferenceMonth": 9,
      "title": "TaPRA Conference 2026",
      "typesenseCollection": "tapra_sessions_2026",
      "publicdir": "tapra2026",

      "elements": {
        "sidebar": true
      },
      "results" : {
        "showChair": false,
        "showBio": true,
        "showTeams": true,
        "showInPerson": true
      },
      "facets" : {
        "StreamName": "Session",
        "BuildingFacet": false,
        "RoomFacet": false
      },
      "schedule": {}
    }
  }
}
